// TODO: cleanup with cp_annotation_createproject_agent ff

/**
 * Appends a trimmed synonym. A blank value, or one that matches an existing synonym
 * ignoring case, leaves the list unchanged (same reference).
 */
export const addSynonym = (synonyms: string[], value: string): string[] => {
  const trimmed = value.trim();
  if (!trimmed) return synonyms;
  const key = trimmed.toLowerCase();
  if (synonyms.some((synonym) => synonym.toLowerCase() === key)) return synonyms;
  return [...synonyms, trimmed];
};
